import styled from 'styled-components'

export const ToolbarEditorUi = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 8px;
  gap: 2px;
  background-color: white;
`
